import * as turf from '@turf/turf';
import moment from 'moment';
import api from '../../api';
import environment from '../../environment';
import { loading, unloading } from '../../shared';
import translate from '../tools/translate';
import Dialog from './Dialog';
import _ from "lodash";
import { feature } from 'topojson-client';
import map from '../map';

var groupProp = 'NetworkName';
var brandProp = 'PinName';

var customLabels = {
    PinName: 'Marca',
    NetworkName: 'Rede'
};

class StoresAfterSales extends Dialog {
    constructor(area, _type) {
        var contexts = [
            { label: environment.get('CONFIG.CLIENT'), context: 'NetworkAfterSales', mainLayer: true },
            { label: translate('Common.CompetitorsAfterSales'), context: 'CompetitorsAfterSales' },
        ];
        super(translate('Common.Stores'), area, contexts);
        this.rangePicking = true;
        this._features = [];
        this.saveAsExcel = this.saveAsExcel.bind(this);
    }

    populateLayers() {
        this.preventMultipleCalls();
        this._features = [];

        const contexts = [
            {
                context: "NetworkAfterSales",
                api: function () { return api.afterSales.get.stores.allNetwork(); }
            },
            {
                context: "CompetitorsAfterSales",
                api: function () { return api.afterSales.get.stores.allCompetitors(); }
            }
        ];

        const self = this;

        const queue = contexts.map(function (context) {
            return context.api()
                .then(function (topojson) {
                    if (topojson && topojson.objects && topojson.objects.output) {
                        const geojson = feature(topojson, topojson.objects.output);
                        if (geojson && geojson.features && geojson.features.length) {
                            const layer = {
                                getCurrentFeatures: () => geojson.features,
                                toGeoJSON: () => geojson
                            };
                            self.addToLayers(layer);
                        }
                    }
                });
        });

        return Promise.all(queue).then(() => this.enablePopulateLayers());
    }


    createDropdownOptions() {
        var allProps = this.featuresProperties;

        return [groupProp, brandProp]
            .filter(function (prop) {
                return allProps.some(function (obj) {
                    return !!obj[prop];
                });
            })
            .map(function (val) {
                return {
                    text: customLabels[val] || translate('Common.' + val),
                    value: val
                };
            });
    }

    aggregateBy(property) {
        var result = {};
        var props = this.featuresProperties;

        for (var i = 0; i < props.length; i++) {
            var val = props[i][property];
            var key = val != null ? val : 'Indefinido';
            if (!result[key]) {
                result[key] = 0;
            }
            result[key]++;
        }

        return result;
    }

    get calculateTotals() {
        return this.featuresProperties.length;
    }

    shouldSumByAverage() {
        return false;
    }

    shouldSumByTotal() {
        return false;
    }

    saveAsExcel(e) {
        e.preventDefault();
        loading();

        setTimeout(() => {
            const bbox = turf.bbox(this._shape);
            const [minLng, minLat, maxLng, maxLat] = bbox;
            const lineString = `LINESTRING(${minLng} ${minLat}, ${maxLng} ${maxLat})`;

            const payload = {
                storesIds: this.featuresProperties.map(x => x.Id),
                filename: `Neocom_Lojas Selecionadas_v${moment().format('YYYYMMDD')}.xlsx`,
                bbox: lineString,
                type: 3,
            };
            unloading();
            return api.afterSales.get.stores.export(payload);
        }, 300);
    }
}

export default StoresAfterSales;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/StoresAfterSales.js